import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnimationOptions } from 'ngx-lottie';
import { Subject, Subscription, from } from 'rxjs';
import { LottieService } from 'src/app/service/animations/lottie.service';
import { UsuarioServiceProvider } from 'src/app/service/index.providers';

@Component({
  selector: 'app-course-details-modal',
  templateUrl: './course-details-modal.component.html',
  styleUrls: ['./course-details-modal.component.scss'],
})
export class CourseDetailsModalComponent  implements OnInit,OnDestroy {
  // @Output() goToCourseClick: EventEmitter<any> = new EventEmitter<any>();

 @Input() coverUrl:string;
 @Input() teaserUrl:string;
 @Input() courseName:string;
 @Input() percentage:number;
 @Input() completedTopics:string;
 @Input() allTopics:string;
 @Input() duration:string;
 @Input() courseTags = [];
 @Input() description:string;
 @Input() rewardCoins:number;
 @Input() coinCustomImage:string;
 @Input() courseIsLocked:string;
 @Input() hasSurvey:boolean;
 @Input() hasEvaluation:boolean;
 @Input() hasTasks:boolean;
 @Input() hasChecklist:boolean;
 @Input() topics = [];
 @Input() isPath:boolean = false;
 @Input() completedBlocks:number;
 @Input() allBlocks:number;
 @Input() blocks = [];
 @Input() currentBlockId:any;
 @Input() loading:boolean = false;
 @Input() courseData$: Subject<any>;
 @Input() address:string;
 @Input() eventIsLocked:boolean;
 @Input() fromCalendar:boolean = false;
 @Input() courseStartDate:string;
 @Input() eventIsSynced:boolean;

 coinOptions: AnimationOptions | null = null;
 topicActiveIdx = [];
 teaserIsPlaying:boolean = false;
 usuario: any;
 hasCalendarIntegrationAvailable: boolean = false;
 private userDataSub: Subscription;
 private courseDataSub: Subscription;
  constructor(
    private modalCtrl: ModalController,
    private lottieService: LottieService,
    private up: UsuarioServiceProvider,
  ) { }

  ngOnInit() {
    this.setAnimations();
    this.userDataSub = this.up.data_usuario$.subscribe((data) => {
        this.usuario = data;
         this.hasCalendarIntegrationAvailable = this.usuario?.has_calendar_integration;
    });
    if (this.courseData$) {
      this.courseDataSub = this.courseData$.subscribe((data) => {
        this.coverUrl = data.coverUrl;
        this.teaserUrl = data.teaserUrl;
        this.courseName = data.courseName;
        this.percentage = data.percentage;
        this.completedTopics = data.completedTopics;
        this.allTopics = data.allTopics;
        this.duration = data.duration;
        this.courseTags = data.courseTags;
        this.description = data.description;
        this.rewardCoins = data.rewardCoins;
        this.coinCustomImage = data.coinCustomImage;
        this.courseIsLocked = data.courseIsLocked;
        this.hasSurvey = data.hasSurvey;
        this.hasEvaluation = data.hasEvaluation;
        this.hasTasks = data.hasTasks;
        this.hasChecklist = data.hasChecklist;
        this.topics = data.topics;
        this.address = data.address;
        this.eventIsLocked = data.eventIsLocked;
        this.fromCalendar = data.fromCalendar;
        this.courseStartDate = data.courseStartDate;
        this.eventIsSynced = data.eventIsSynced;
        this.loading = false;
      });
    }
  }

  onClickBtn() {
    // e.stopPropagation();
    this.modalCtrl.dismiss( this.courseIsLocked ? "locked" : "available");
  }
  onClickBtnCalendar() {
    // e.stopPropagation();
    this.modalCtrl.dismiss( this.courseIsLocked || this.eventIsLocked ? "locked" : "available");
  }

  sendCalendarEvent() {
    this.modalCtrl.dismiss( "integrateCalendarEvent");
  }


  closeModal() {
    this.modalCtrl.dismiss();
  }

  setAnimations() {
    this.coinOptions = this.lottieService._coinOptions;
  }

  get blocksCompletedCount(): number {
    return this.completedBlocks ?? (this.blocks || []).filter((b) => b.completado).length;
  }

  get blocksTotalCount(): number {
    return this.allBlocks ?? (this.blocks || []).length;
  }

  trackById(_: number, item) {
    return item?.id;
  }

  openTopicDetail(topicIndex) {
    if( this.topicActiveIdx.includes(topicIndex) ) {
      this.topicActiveIdx = this.topicActiveIdx.filter( idx => idx !== topicIndex);
    } else {
      this.topicActiveIdx.push(topicIndex);
    };
  }

   ngOnDestroy() {
    if(this.userDataSub) this.userDataSub.unsubscribe();
    if(this.courseDataSub) this.courseDataSub.unsubscribe();
	}

}
